// Главная прораба на телефоне (макет «Приложение прораба», 22.10.2026): этаж, четыре крупные плитки,
// план на сегодня с процентами, готовность этажа, открытая проблема и «Завершить день».

import { fmtNum } from "../../shared/format";
import { useLive } from "../../shared/live";
import { navigate } from "../../shared/router";
import { TopBar } from "../../shared/shell";
import { Bar, Button, Icon, Loading, useAsync } from "../../shared/ui";
import { Ring } from "../charts";
import { api, floorAbbr, floorName, isStage, live } from "../ctx";

export function HomePage({ id }: { id: string }) {
  const p = useAsync<any>(() => api.get(`/buildings/${id}/production`), [id]);
  const t = useAsync<any>(() => api.get(`/buildings/${id}/reports/today`), [id]);
  useLive(live, ["report.", "cycle.", "issue."], () => { p.reload(); t.reload(); }, 1000);
  const v = p.data;
  const tasks: any[] = t.data?.tasks || [];
  const issue = v?.decisions.find((x: any) => x.kind === "issue");
  const submitted = t.data?.report?.status === "submitted";
  return (
    <>
      <TopBar title={v ? `${v.building.name}` : "Главная"} />
      <div className="content mobile-form home">
        {!v ? <Loading error={p.error} onRetry={p.reload} /> : (
          <>
            <div className="panel pad row" style={{ justifyContent: "space-between", flexWrap: "nowrap" }}>
              <div>
                <div style={{ fontSize: 22, fontWeight: 700 }}>{isStage(v.floor_current) ? floorName(v.floor_current) : <>Этаж {v.floor_current ?? "—"} / {v.floors_total}</>}</div>
                <div className="small muted">{v.building.project_name} · {v.people.plan ? `${v.people.plan} чел. в смену` : ""}</div>
              </div>
              {v.cycle && <Ring value={v.cycle.progress_pct} size={60} label="Готовность этажа" />}
            </div>
            <div className="tiles">
              <button className="tile green" onClick={() => navigate(`/b/${id}/report`)}><Icon name="report" /><b>Работа</b><span>выполнение за смену</span></button>
              <button className="tile blue" onClick={() => navigate(`/b/${id}/grid`)}><Icon name="grid" /><b>Захватки</b><span>этажи и захватки</span></button>
              <button className="tile orange" onClick={() => navigate(`/b/${id}/report?step=2`)}><Icon name="crew" /><b>Люди</b><span>численность, простой</span></button>
              <button className="tile red" onClick={() => navigate(`/b/${id}/issues?new=1`)}><Icon name="issue" /><b>Проблема</b><span>сообщить с фото</span></button>
            </div>
            <div className="panel">
              <div className="ph"><h2 className="grow">План на сегодня</h2><Button size="small" variant="ghost" onClick={() => navigate(`/b/${id}/report`)}>Отметить</Button></div>
              <div className="pb stack tight">
                {!t.data ? <Loading error={t.error} /> : tasks.length === 0 ? <p className="muted" style={{ margin: 0 }}>Работ по плану на сегодня нет.</p> : tasks.map((x) => {
                  const pct = x.entered_percent ?? x.fact_percent;
                  return (
                    <div key={x.task_id} className="row between today-task">
                      <span><b>{x.grip}</b> · {x.work}<span className="small muted"> · {floorAbbr(x.floor)}</span></span>
                      <span className={`num strong ${pct >= 100 ? "good" : pct < x.planned_percent ? "bad" : ""}`}>{fmtNum(pct, 0)}%</span>
                    </div>
                  );
                })}
                {v.cycle && (
                  <div className="stack tight" style={{ marginTop: 6 }}>
                    <div className="row between small"><span>Готовность этажа</span><b>{fmtNum(v.cycle.progress_pct, 0)}%</b></div>
                    <Bar value={v.cycle.progress_pct} warn={v.cycle.progress_pct < v.cycle.planned_progress_pct - 10} />
                  </div>
                )}
              </div>
            </div>
            <Button variant="primary" size="big" block onClick={() => navigate(`/b/${id}/report?step=2`)}>{submitted ? "Отчёт сдан — изменить" : "Завершить день: люди и отчёт"}</Button>
            {issue && (
              <button className="issue-card" onClick={() => navigate(`/b/${id}/issues`)}>
                <Icon name="issue" />
                <span className="grow"><b>Проблема</b><span>{issue.title}</span><span className="small muted">{[issue.where, issue.detail].filter(Boolean).join(" · ")}</span></span>
              </button>
            )}
          </>
        )}
      </div>
    </>
  );
}
